
import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { AuthContext } from "../../authentication/AuthContext";

const LeftSidebarMenu = ({ toggleActive }) => {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const isActiveLink = (path) => (location.pathname === path ? "active" : "");
  const isSuperAdmin = user?.role === "superadmin";

  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (location.pathname === "/dashboard/beauty-salon/") {
      const storedTheme = localStorage.getItem("beautySalonSidebarTheme");
      if (storedTheme) {
        setIsDark(storedTheme === "dark-theme");
      } else {
        setIsDark(true);
        localStorage.setItem("beautySalonSidebarTheme", "dark-theme");
      }
    } else {
      setIsDark(false);
    }
  }, [location.pathname]);

  return (
    <Box
      className={`leftSidebarDark hide-for-horizontal-nav ${location.pathname === "/dashboard/beauty-salon/" && isDark
          ? "dark-theme"
          : ""
        }`}
    >
      <Box className="left-sidebar-menu">
        <Box className="logo" sx={{ display: "flex", alignItems: "start" }}>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <img src="/images/Bud-e-logo.png" alt="logo-icon" width={35} height={35} />
            <Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  lineHeight: 1.2,
                  color: "var(--blackColor) !important",
                }}
              >
                Askbud-i
              </Typography>
            </Box>
          </Link>
        </Box>

        <Box className="burger-menu" onClick={toggleActive}>
          <Typography component={"span"} className="top-bar"></Typography>
          <Typography component={"span"} className="middle-bar"></Typography>
          <Typography component={"span"} className="bottom-bar"></Typography>
        </Box>

        <Box className="sidebar-inner">
          <Box className="sidebar-menu">

            {/* 1. Dashboard */}
            <Link to="/" className={`sidebar-menu-link ${isActiveLink("/")}`}>
              <i className="material-symbols-outlined">home</i>
              <Typography component="span" className="title">Dashboard</Typography>
            </Link>

            {/* 2. Revenue */}
            <Link to="/revenue" className={`sidebar-menu-link ${isActiveLink("/revenue")}`}>
              <i className="material-symbols-outlined">attach_money</i>
              <Typography component="span" className="title">Revenue</Typography>
            </Link>

            {/* 3. Client Management */}
            <Link to="/client-management" className={`sidebar-menu-link ${isActiveLink("/client-management")}`}>
              <i className="material-symbols-outlined">groups</i>
              <Typography component="span" className="title">Client Management</Typography>
            </Link>

            {/* 4. Client Stores */}
            <Link to="/client-stores" className={`sidebar-menu-link ${isActiveLink("/client-stores")}`}>
              <i className="material-symbols-outlined">shopping_cart</i>
              <Typography component="span" className="title">Client Stores</Typography>
            </Link>

            {/* 5. Client Order */}
            <Link to="/clients-order" className={`sidebar-menu-link ${isActiveLink("/clients-order")}`}>
              <i className="material-symbols-outlined">orders</i>
              <Typography component="span" className="title">Client Order</Typography>
            </Link>

            {/* 6. Client Products */}
            <Link to="/products" className={`sidebar-menu-link ${isActiveLink("/products")}`}>
              <i className="material-symbols-outlined">package_2</i>
              <Typography component="span" className="title">Client Products</Typography>
            </Link>

            {/* 7. Client Feedback */}
            <Link to="/client-feedback" className={`sidebar-menu-link ${isActiveLink("/client-feedback")}`}>
              <i className="material-symbols-outlined">feedback</i>
              <Typography component="span" className="title">Client Feedback</Typography>
            </Link>

            {/* 8. Chat Problems Report */}
            <Link to="/chat-problems-report" className={`sidebar-menu-link ${isActiveLink("/chat-problems-report")}`}>
              <i className="material-symbols-outlined">warning</i>
              <Typography component="span" className="title">Chat Problem Report</Typography>
            </Link>

            {/* 9. Chat Transcripts */}
            <Link to="/chat-transcripts" className={`sidebar-menu-link ${isActiveLink("/chat-transcripts")}`}>
              <i className="material-symbols-outlined">article</i>
              <Typography component="span" className="title">Chat Transcripts</Typography>
            </Link>

            {/* 10. User Management - Superadmin Only */}
            {isSuperAdmin && (
              <Link to="/user-management" className={`sidebar-menu-link ${isActiveLink("/user-management")}`}>
                <i className="material-symbols-outlined">person</i>
                <Typography component="span" className="title">User Management</Typography>
              </Link>
            )}

            {/* 10. Notifications */}
            <Link to="/notifications" className={`sidebar-menu-link ${isActiveLink("/notifications")}`}>
              <i className="material-symbols-outlined">notifications</i>
              <Typography component="span" className="title">Notifications</Typography>
            </Link>

            {/* 11. Analytics */}
            <Link to="/analytics" className={`sidebar-menu-link ${isActiveLink("/analytics")}`}>
              <i className="material-symbols-outlined">finance_mode</i>
              <Typography component="span" className="title">Analytics</Typography>
            </Link>


            {/* Batch Jobs */}
            <Link to="/batch-jobs" className={`sidebar-menu-link ${isActiveLink("/batch-jobs")}`}>
              <i className="material-symbols-outlined">manufacturing</i>
              <Typography component="span" className="title">Batch Jobs</Typography>
            </Link>

            {/* Job Logs */}
            <Link to="/job-logs" className={`sidebar-menu-link ${isActiveLink("/job-logs")}`}>
              <i className="material-symbols-outlined">receipt_long</i>
              <Typography component="span" className="title">Batch Logs</Typography>
            </Link>


          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LeftSidebarMenu;

